// import React from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { X } from "lucide-react";
import { useState } from "react";

const CustomRoleDeleteModal = (props) => {

    const [isHovered, setIsHovered] = useState(false);
    return (
        <Modal
            show={props.show}
            onHide={() => props.onHide(false)}
            dialogClassName="modal-38"
            // aria-labelledby="contained-modal-title-vcenter"
            centered
            style={{
                display: "flex",
                flexDirection: "column",
                // border: "1px solid red",
                borderRadius: "8px",
                padding: "16px 24px",  // reduced padding
                Width: "585px",     // constrain horizontal width
                margin: "0 auto"       // center modal
            }}

        >
            <Modal.Body className="text-center " style={{
                display: "flex", flexDirection: "column",
            }}>
                <div style={{ display: 'flex', flexDirection: "column", gap: "16px", }}>
                    {/* <X className="st-close-icon position-absolute" style={{ top: '15px', right: '15px', cursor: 'pointer' }} onClick={props.onHide} /> */}
                    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                        <div className="al-rp-img d-flex justify-content-center">
                            <img
                                style={{
                                    width: "5rem",
                                }}
                                src={`${process.env.PUBLIC_URL}/img/delete-icon.png`}
                                alt="Alert Image"
                            />
                        </div>
                        <h4 className="font-clash-display" style={{
                            fontSize: "30px", lineHeight: "36px", letterSpacing: "0%",
                            color: "#1F2937"
                        }}>
                            Delete Roleplay
                        </h4>
                        <div>
                            <p className="font-plus-jakarta-sans" style={{
                                // font: "Plus Jakarta Sans",
                                padding: "0px",
                                // margin: "0px",
                                fontWeight: "500",
                                lineHeight: "24px",
                                fontSize: "16px",
                                letterSpacing: "0%",
                                verticalAlign: "middle",
                                color: "#1F2937"
                            }}>
                                Are you sure want to delete this roleplay?
                            </p>
                        </div>
                    </div>

                    {/*  */}
                    <div style={{ borderBottom: "1px solid #D1D5DB", }}>
                        <div>
                            <Button
                                onMouseOver={() => setIsHovered(true)}
                                onMouseOut={() => setIsHovered(false)}
                                className={`font-plus-jakarta-sans ${isHovered ? "next-button" : ""}`}
                                style={{
                                    backgroundColor: isHovered ? undefined : "#EF4444", // only set red if not hovered
                                    border: "none",
                                    borderRadius: "27px",
                                    padding: "8px 20px",
                                    fontWeight: "700",
                                    fontSize: "18px",
                                    lineHeight: "28px",
                                    letterSpacing: "0%"
                                }}
                                onClick={props.onDelete}
                            >
                                Delete Roleplay
                            </Button>
                            {/*  Secondary link */}
                            <div style={{ marginTop: "8px", marginBottom: "8px" }}>
                                <a href="#" onClick={() => props.onHide(false)} className="font-plus-jakarta-sans" style={
                                    {
                                        fontWeight: "500",
                                        fontSize: "16px",
                                        lineHeight: "24px",
                                        letterSpacing: "0%",
                                        color: "#23B4C3",
                                        textDecoration: "none"
                                    }
                                }>
                                    Back
                                </a>
                            </div>
                        </div>
                    </div>
                    {/* <div style={{ display: "flex", justifyContent: "center", alignContent: "center", }}>
                        <p>
                            “You're only deleting the role play. Feedback remains available under <br /><strong>
                                ”My role plays”
                            </strong>
                        </p>
                    </div> */}
                </div>


            </Modal.Body>

        </Modal>
    );
};

export default CustomRoleDeleteModal;
